import gql from 'graphql-tag'
import * as React from 'react'
import { Query } from 'react-apollo'
import Spin from 'web-makeup/dist/Spin'
import { flatten, sortBy } from 'lodash'

import { GetAllProducersFilter } from '../../../typings/types'
import CheckboxPicker from '../../CheckboxPicker'

export const ALL_PRODUCERS = gql`
  query GetAllProducersFilter {
    allProducers(producerFilter: { activated: true }, pageSize: 100) {
      producers {
        activated
        user {
          name
          email
          uuid
        }
      }
    }
  }
`

interface Props {
  assigneeEmails?: string[]
  onChange: (emails: string[]) => void
}

function getOptions(producers: GetAllProducersFilter.Producers[]) {
  const options = producers.map(producer => {
    const { user } = producer
    return { label: user.name, value: user.email }
  })
  return sortBy(options, o => o.label)
}

const ProducerFilter: React.SFC<Props> = ({ assigneeEmails, onChange }) => {
  return (
    <Query<GetAllProducersFilter.Query> query={ALL_PRODUCERS}>
      {({ loading, data }) => (
        <Spin spinning={loading}>
          {data &&
            data.allProducers && (
              <CheckboxPicker
                defaultValue={flatten([assigneeEmails || []])}
                options={getOptions(data.allProducers.producers)}
                onChange={values => onChange(values)}
                placeholder="Producer"
              />
            )}
        </Spin>
      )}
    </Query>
  )
}

export default ProducerFilter



// WEBPACK FOOTER //
// ./src/components/ProducerRequests/ProducerFilter/ProducerFilter.tsx